import { Shape } from './shape';
import { DeckingBoard } from './decking-board';
import { LayingType } from './laying-type';
import { ConfigurationSide } from './configuration-side';
import { DeckingBoardType } from './decking-board-type';
import { DeckingBoardFinishing } from './decking-board-finishing';
import { DeckingBoardFinishingType } from './decking-board-finishing-type';
import { Configuration2D } from '../../configuration2d';
import { DeckingBoardsLocation } from './decking-boards-location';
import { ResumeDto } from './resume-dto';
import { ShapeTypeEnum } from 'src/app/enum/shape-type.enum';
import { Joist } from './joist';
import { FixationGroup } from './fixation-group';
import { ConfigurationAccessory } from './configuration-accessory';

export class Configuration extends Configuration2D {
  isComplete: boolean;
  raisedHeight: number;

  location: DeckingBoardsLocation;

  shapeId: number;
  shape: Shape;

  deckingBoardId: number;
  deckingBoard: DeckingBoard;

  deckingBoardTypeId: number;
  deckingBoardType: DeckingBoardType;

  deckingBoardFinishingId: number;
  deckingBoardFinishing: DeckingBoardFinishing;

  deckingBoardFinishingTypeId: number;
  deckingBoardFinishingType: DeckingBoardFinishingType;

  joistId: number;
  joist: Joist;

  fixationGroupId: number;
  fixationGroup: FixationGroup;

  hasValidQuotation: boolean;

  layingTypeId: number;
  layingType: LayingType;

  configurationSides: ConfigurationSide[];
  configurationAccessories: ConfigurationAccessory[];

  _resume: ResumeDto;

  get resume() {
    return this._resume;
  }

  override set resume(resume: ResumeDto) {
    this._resume = resume;
  }

  get sideALength(): number {
    if (this.shape && this.configurationSides) {
      let side = this.configurationSides.find(s => s.name == 'A');
      if (side) {
        return side.length;
      }
    }

    return 0;
  }
}

export function CheckConfigurationSides(configuration: Configuration): boolean {
  let value = false;

  switch (configuration.shape.shapeType) {
    case ShapeTypeEnum.poolOutline:
      if (
        configuration.configurationSides.find(s => s.name === 'A').length >
          configuration.configurationSides.find(s => s.name === 'E').length &&
        configuration.configurationSides.find(s => s.name === 'B').length >
          configuration.configurationSides.find(s => s.name === 'F').length
      ) {
        value = true;
      }
      break;

    default:
      value = true;
      break;
  }

  return value;
}
